module.exports = __webpack_public_path__ + "img/p13.66b1c996.png";